import React from "react";
import gourmettaTransparent from "../assets/gourmetta_transparent_white.svg";

const Logo: React.FC = () => <img src={gourmettaTransparent} alt={"gourmetta logo"} className={"z-20 fixed hdhoch:bottom-20 wqhdhoch:bottom-36 hdhoch:right-12 wqhdhoch:right-24 hdhoch:max-h-24 wqhdhoch:max-h-max"} />

export default Logo;